// 地区选择数据（由后端 area_domestic.json / area_overseas.json 生成，统一来自 src/utils/areaData.ts）
import { DOMESTIC_AREA, OVERSEAS_AREA_ZH, OVERSEAS_AREA_EN } from '@/utils/areaData';

export type BirthPlaceTree = Record<string, Record<string, string[]>>;

export const DOMESTIC_DATA: BirthPlaceTree = DOMESTIC_AREA;

export function getOverseasData(lang: string): BirthPlaceTree {
  return lang === 'en' ? OVERSEAS_AREA_EN : OVERSEAS_AREA_ZH;
}
